import React from "react";
import Content from "../../layout/content/Content";

const TermsAndConditions = () => {
  return <Content>Terms and Conditions</Content>;
};

export default TermsAndConditions;
